__turbopack_context__.v({
  "critical": "TextField-module__3DXP1q__critical",
  "error": "TextField-module__3DXP1q__error",
  "errorShow": "TextField-module__3DXP1q__errorShow",
  "field": "TextField-module__3DXP1q__field",
  "highlightOnFocus": "TextField-module__3DXP1q__highlightOnFocus",
  "input": "TextField-module__3DXP1q__input",
  "inputBorder": "TextField-module__3DXP1q__inputBorder",
  "label": "TextField-module__3DXP1q__label",
  "searchIcon": "TextField-module__3DXP1q__searchIcon",
});
